import { memo, type ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface FilterToggleProps {
  icon?: ReactNode;
  label: string;
  isActive: boolean;
  onChange: (active: boolean) => void;
  dotColor?: string;
}

export const FilterToggle = memo(function FilterToggle({
  icon,
  label,
  isActive,
  onChange,
  dotColor,
}: FilterToggleProps) {
  return (
    <button
      type="button"
      onClick={() => onChange(!isActive)}
      className={cn(
        "tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-rounded-lg tw-border tw-transition-all tw-duration-150",
        "tw-cursor-pointer hover:tw-border-primary/50",
        isActive
          ? "tw-bg-primary/10 tw-border-primary tw-text-primary"
          : "tw-bg-muted/30 tw-border-border tw-text-muted-foreground"
      )}
    >
      {icon && (
        <span className={cn("tw-w-4 tw-h-4", isActive && "tw-text-primary")}>
          {icon}
        </span>
      )}
      {dotColor && !icon && (
        <span
          className={cn("tw-w-2 tw-h-2 tw-rounded-full tw-flex-shrink-0", {
            [dotColor]:
              !dotColor.startsWith("#") && !dotColor.startsWith("rgb"),
          })}
          style={
            dotColor.startsWith("#") || dotColor.startsWith("rgb")
              ? { backgroundColor: dotColor }
              : undefined
          }
        />
      )}
      <span className="tw-text-xs tw-font-medium">{label}</span>
    </button>
  );
});
